import { Mail } from 'lucide-react'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/shared/ui/dialog'

interface PasswordResetMailInfoProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  email: string
}

export function PasswordResetMailInfo({ open, onOpenChange, email }: PasswordResetMailInfoProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Mail className="w-5 h-5" />
            {m.checkYourEmail()}
          </DialogTitle>
          <DialogDescription>{m.passwordResetEmailSent({ email })}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>{m.close()}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
